module.exports = __webpack_public_path__ + "img/abstract-2.7bd1f759.svg";